import { TERMINALS_FETCHING_CHANGED, TERMINALS_LIST_CHANGED } from '../actions/types';

const initialState = {
    terminals: [],
    isFetching: false,
};

const terminals = (state = initialState, action) => {
    const { payload } = action;

    switch (action.type) {
        case TERMINALS_LIST_CHANGED:
            return {
                ...state,
                terminals: payload,
            };
        case TERMINALS_FETCHING_CHANGED:
            return { ...state, isFetching: payload };
        default:
            return state;
    }
};

export default terminals;
